<script>
export default {
  name: 'FocoIntegrationSection',
  components: {
    FormSection: () => import('@/components/general/FormSection'),
    InputField: () => import('@/components/general/InputField'),
    SelectField: () => import('@/components/general/SelectField'),
    Checkbox: () => import('@/components/general/Checkbox')
  },

  props: {
    section: {
      type: Object,
      required: true
    },

    values: {
      type: Object,
      required: true
    },

    validations: {
      type: Object,
      default: () => ({})
    },

    editable: {
      type: Object,
      default: () => ({})
    },

    persisted: {
      type: Object,
      default: () => ({})
    }
  },

  computed: {
    fields () {
      return this.section.fields.map(schemaField => ({
        field: schemaField.field,
        type: schemaField.type,
        secret: !!schemaField.secret,
        hint: schemaField.hint || null,
        label: this.$t(schemaField.label),
        options: (schemaField.options || []).map(option => ({
          text: this.$t(option.text),
          value: option.value
        })),
        items: [
          {
            value: schemaField.field,
            label: this.$t(schemaField.label)
          }
        ]
      }))
    },

    title () {
      return this.$t(this.section.title)
    }
  },

  methods: {
    hintOf (item) {
      if (item.secret && this.persisted[item.field]) {
        return this.$t('management.general:field.hint.foco_client_secret.saved')
      }

      return item.hint ? this.$t(item.hint) : null
    },

    validationOf (item) {
      return this.validations[item.field] || {}
    },

    isDisabled (item) {
      return this.editable[item.field] === false
    },

    updateField (item, value) {
      this.$emit('input', {
        field: item.field,
        value
      })
    }
  }
}
</script>

<template>
  <FormSection :title="title">
    <template v-for="item in fields">
      <SelectField
        v-if="item.type === 'select'"
        :key="item.field"
        :value="values[item.field]"
        :label="item.label"
        :hint="hintOf(item)"
        :items="item.options"
        :validation="validationOf(item)"
        :disabled="isDisabled(item)"
        @input="updateField(item, $event)"
      />

      <Checkbox
        v-else-if="item.type === 'toggle'"
        :key="item.field"
        :value="values[item.field]"
        :items="item.items"
        :hint="hintOf(item)"
        :disabled="isDisabled(item)"
        switch-type
        @input="updateField(item, $event)"
      />

      <InputField
        v-else
        :key="item.field"
        :value="values[item.field]"
        :label="item.label"
        :hint="hintOf(item)"
        :type="item.type"
        autocomplete="off"
        :validation="validationOf(item)"
        :disabled="isDisabled(item)"
        @input="updateField(item, $event)"
      />
    </template>
  </FormSection>
</template>
